type Props = {
  propertyCode: string
  gameCode: string
  subId: string
  isFav: boolean
}

type FavGamesResponse = {
  error: boolean
  errorMessage?: string
}

export const updateFavGames = async ({propertyCode, gameCode, isFav, subId}: Props): Promise<FavGamesResponse> => {
  try {
    const uri = `${process.env.METEOR_GO_URL}/v2/user/preference/game/favourite`
    const response = await fetch(uri, {
      credentials: 'include',
      method: 'PUT',
      body: JSON.stringify({
        propertyCode: propertyCode,
        gameCode,
        subId,
        isFavourite: isFav,
      }),
    })
    const data: FavGamesResponse = await response.json()
    return data
  } catch (err: any) {
    console.log('Failed to add to recently played', err)
  }
  return {error: false}
}
